import commonFunction from '@/common/commonFunction';
export default {
	TaxRegisData: function(state) {
		return state.TaxRegisData;
	},
	Total: function(state) {
		return state.Total;
	},
	hadRegisteredDeclaration: function(state) {
		return state.hadRegisteredDeclaration;
	}
};
